import { memo, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiListGroupedCard } from "@miplatform/components";
import {
  groupActivitiesByDate,
  groupActivitiesForTimeline,
} from "@miplatform/utils";
import { ActivityCard, ActivityTimeline } from "@mibuildweb/components";
import { Box } from "@mui/material";

export const CloseoutActivity = memo(
  ({
    open = true,
    attemptModifiedOn,
    dataProcessedTime,
    activities,
    getAttemptActivities,
  }) => {
    const { classes } = useStyles();

    useEffect(() => {
      if (open) {
        getAttemptActivities();
      }
    }, [open, dataProcessedTime, attemptModifiedOn, getAttemptActivities]);

    return (
      <Box className={classes.root}>
        {Object.entries(groupActivitiesByDate(activities)).map(
          ([date, activities]) => {
            const timelineData = {
              [date]: groupActivitiesForTimeline(activities),
            };

            return (
              <MiListGroupedCard
                key={date}
                title={date}
                renderCard={
                  <ActivityTimeline
                    disableSpacing
                    data={timelineData}
                    showHeader={false}
                    showDate={false}
                    renderDetail={(activity) => (
                      <ActivityCard key={activity.id} activity={activity} />
                    )}
                  />
                }
              />
            );
          }
        )}
      </Box>
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
